var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert_2_",
    "data-name": "alert (2)",
    transform: "translate(-4.012 -7.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_265",
    "data-name": "Union 265",
    d: "M13220.011,5159.824v-.023a.5.5,0,0,1,1,0,.507.507,0,0,1-.5.5A.488.488,0,0,1,13220.011,5159.824Zm0-1.46v-2.611a.5.5,0,0,1,1,0v2.611a.5.5,0,0,1-1,0Z",
    transform: "translate(-13210.5 -5144.299)",
    fill: "#e64a31"
  }), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE_32_",
    transform: "translate(4.012 7.508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15164",
    "data-name": "Group 15164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26347",
    "data-name": "Path 26347",
    d: "M14.3,18.508H5.724a1.679,1.679,0,0,1-1.484-.92,1.843,1.843,0,0,1,.017-1.807L8.545,8.363a1.686,1.686,0,0,1,2.934,0l4.288,7.418a1.843,1.843,0,0,1,.018,1.806,1.681,1.681,0,0,1-1.485.921Zm-4.288-10.1a.839.839,0,0,0-.733.422L4.991,16.246a.919.919,0,0,0,0,.9.837.837,0,0,0,.737.463H14.3a.838.838,0,0,0,.737-.464.917.917,0,0,0,0-.9L10.745,8.828a.838.838,0,0,0-.734-.422Z",
    transform: "translate(-4.012 -7.508)",
    fill: "#e64a31"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportError);
export default __webpack_public_path__ + "static/media/report-error.258a1d6b670ec9f14ba15def7851f453.svg";
export { ForwardRef as ReactComponent };